export enum deviceType {
  mobile,
  pc,
  api,
}
